export const CONTROL_MODIFIER = {
  active: 'active',
  date: 'date',
  disabled: 'disabled',
  error: 'error',
  filled: 'filled',
  password: 'password',
  readonly: 'readonly',
};

export const INPUT_ATTRIBUTE = {
  disabled: 'disabled',
  readonly: 'readonly',
  type: 'type',
};
